import React from 'react';
import { Segmented, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const LowPowerIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
    <circle cx="24" cy="24" r="6" />
    <line x1="24" y1="4" x2="24" y2="14" />
    <line x1="24" y1="34" x2="24" y2="44" />
    <line x1="4" y1="24" x2="14" y2="24" />
    <line x1="34" y1="24" x2="44" y2="24" />
  </svg>
);

const FullPowerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
    <circle cx="24" cy="24" r="6" fill="currentColor" fillOpacity="0.15" />
    <line x1="24" y1="2" x2="24" y2="14" />
    <line x1="24" y1="34" x2="24" y2="46" />
    <line x1="2" y1="24" x2="14" y2="24" />
    <line x1="34" y1="24" x2="46" y2="24" />
    <line x1="9.4" y1="9.4" x2="16" y2="16" />
    <line x1="32" y1="32" x2="38.6" y2="38.6" />
    <line x1="38.6" y1="9.4" x2="32" y2="16" />
    <line x1="16" y1="32" x2="9.4" y2="38.6" />
  </svg>
);

const LaserPowerToggle = ({ value, onChange, disabled }) => {
  const toggle = () => {
    if (!disabled) {
      const next = value === 'Full' ? 'Reduced' : 'Full';
      onChange({ target: { value: next } });
    }
  };

  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
      <p style={{ display: 'block', textAlign: 'center', margin: '8px 0 4px 0' }}>
        Laser Power&nbsp;
        <Tooltip title="Less power lowers burn risk, but extends scan time." overlayInnerStyle={{ textAlign: 'center' }}>
          <InfoCircleOutlined />
        </Tooltip>
      </p>
      <div onClick={toggle} style={{ cursor: disabled ? 'not-allowed' : 'pointer', position: 'relative' }}>
        <Segmented
          value={value}
          disabled={disabled}
          style={{ pointerEvents: 'none' }}
          options={[
            {
              value: 'Reduced',
              label: (
                <div style={{ width: 36, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <LowPowerIcon />
                </div>
              ),
            },
            {
              value: 'Full',
              label: (
                <div style={{ width: 36, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <FullPowerIcon />
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default LaserPowerToggle;
